const getDialog = (id) => {
  const element = document.getElementById(id);
  if (element?.tagName !== 'DIALOG') return null;
  if (typeof element.showModal === 'function') return element;

  const dialog = document.createElement('dialog');
  for (const attribute of element.attributes) {
    dialog.setAttribute(attribute.name, attribute.value);
  }
  dialog.innerHTML = element.innerHTML;
  document.body.append(dialog);
  element.parentNode?.removeChild(element);

  return dialog;
};

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!target || typeof target.closest !== 'function') return;

  const openButton = target.closest('[data-size-guide-open]');
  if (openButton) {
    event.preventDefault();
    event.stopPropagation();
    const dialog = getDialog(openButton.dataset.sizeGuideOpen);
    if (!dialog || typeof dialog.showModal !== 'function') return;

    dialog.showModal();
    dialog.querySelector('[data-size-guide-close]')?.focus();
    return;
  }

  const closeButton = target.closest('[data-size-guide-close]');
  if (closeButton) {
    event.preventDefault();
    event.stopPropagation();
    const dialog = closeButton.closest('dialog');
    if (typeof dialog?.close === 'function') dialog.close();
    return;
  }

  if (target.matches('dialog.size-guide-dialog') && typeof target.close === 'function') target.close();
}, true);
